import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { IntercomChat } from '../../utils/thirdParty/IntercomChat';
import { PlatformType } from '../../constants/common';
import GlobalConfig from '../../lib/GlobalConfig';
const ChatSupportBubble = (props) => {
    const { onChatBubbleLoaded, platform } = props;
    const [chatSupportLoading, setChatSupportLoading] = useState(false);
    const [chatSupportAlreadyLoaded, setChatSupportAlreadyLoaded] = useState(false);
    const onReady = () => {
        setChatSupportLoading(false);
        setChatSupportAlreadyLoaded(true);
        onChatBubbleLoaded();
    };
    useEffect(() => {
        IntercomChat.loadIcon();
        IntercomChat.onHide(() => {
            setChatSupportAlreadyLoaded(false);
            setChatSupportLoading(false);
        });
        IntercomChat.onShow(() => {
            if (!chatSupportAlreadyLoaded) {
                setChatSupportAlreadyLoaded(true);
                setChatSupportLoading(true);
            }
        });
    });
    const initLiveChat = () => {
        IntercomChat.load(onReady);
    };
    const sizeOnPlatform = {
        [PlatformType.Mobile]: 16,
        [PlatformType.Desktop]: 23,
        [PlatformType.Tablet]: 23,
    };
    const size = sizeOnPlatform[platform] || sizeOnPlatform[PlatformType.Desktop];
    return (!chatSupportAlreadyLoaded && (_jsxs("div", { id: "fresh-chat-custom", onClick: initLiveChat, "aria-hidden": true, style: {
            boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.2)',
            display: 'none',
        }, className: clsx('iv-flex iv-justify-center iv-items-center', 'iv-fixed', 'iv-bottom-[20px] iv-right-[20px]', 'iv-w-[45px] sm:iv-w-[32px]', 'iv-h-[45px] sm:iv-h-32', 'iv-bg-grey-0 iv-rounded-full', 'iv-cursor-pointer'), children: [chatSupportLoading && (_jsx("span", { className: clsx('iv-animate-spin', 'iv-rounded-full', 'iv-border-[1.1em] iv-border-black-10', 'iv-border-t-black-50', 'iv-text-[2px]', 'iv-p-7') })), _jsx("img", { className: clsx(chatSupportLoading ? 'iv-hidden' : ''), src: `${GlobalConfig.cdn.SHARED_URL}/icons/livechat-icon.svg`, alt: "Livechat", width: size, height: size }), _jsx("div", { id: "unread-notify-count", className: clsx('iv-hidden', 'iv-fixed', 'iv-bottom-[53px] iv-right-[20px]', 'iv-bg-red iv-rounded-full', 'iv-p-4') })] })));
};
export default ChatSupportBubble;
